import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SerieDocumentoInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const SerieDocumentoBusquedaFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-infonota-numeroDocumentoBusqueda', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='SERIE' md={12} htmlFor='input-infonota-serieDocumentoBusqueda' />
      <Col md={12}>
        <Field name='serieDocumentoBusqueda'>
          {({ field }) => (
            <SerieDocumentoInput
              {...field}
              id='input-infonota-serieDocumentoBusqueda'
              disabled={fIsSubmitting}
              isInvalid={iError && iTouched}
              onKeyDown={onKeyDown}
              setFieldValue={setFieldValue}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SerieDocumentoBusquedaFormGroup)
